import React from 'react';

const CrudContext = React.createContext();

export default CrudContext;
